import { parseDef } from "../parseDef.js";
export function parseBrandedDef(_def, refs) {
    return parseDef(_def.type._def, refs);
}
